import React from "react";
import { withRouter } from "react-router-dom";
import TopOwnersOwnedStock from "../../widgets/office/owner/TopOwnersOwnedStock";
import OwnershipShare from "../../widgets/office/owner/OwnershipShare";
// import MySelectedOwners from "../../widgets/office/owner/MySelectedOwners";
// import RecentlySearchedOwners from "../../widgets/office/owner/RecentlySearchedOwners";
import TopOwnersLeasingVolume from "../../widgets/office/owner/TopOwnersLeasingVolume";
import LeaseVolumeOwnershipShare from "../../widgets/office/owner/LeaseVolumeOwnershipShare";
import RentalTrendsOwners from "../../widgets/office/owner/RentalTrendsOwners";
import VacancyTrendsOwners from "../../widgets/office/owner/VacancyTrendsOwners";
class Owner2 extends React.Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row mb-4">
          <div className="col-lg-8">
            <TopOwnersOwnedStock />
          </div>
          <div className="col-lg-4">
            <OwnershipShare />
          </div>
        </div>
        {/* <div className="row mb-4">
          <div className="col-lg-8">
            <MySelectedOwners />
          </div>
          <div className="col-lg-4">
            <RecentlySearchedOwners />
          </div>
        </div> */}
        <div className="row mb-4">
          <div className="col-lg-8">
            <TopOwnersLeasingVolume />
          </div>
          <div className="col-lg-4">
            <LeaseVolumeOwnershipShare />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-6">
            <RentalTrendsOwners />
          </div>
          <div className="col-lg-6">
            <VacancyTrendsOwners />
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Owner2);
